import { useGetDailyEnergySavingData, HubConfig } from 'common';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSync } from '../../contexts/AppSyncContext';

export const useGetEnergySavingData = (days: number = 16) => {
  const { t } = useTranslation();
  const { sensors, hub } = useAppSync();

  const hubConfig: HubConfig | undefined = useMemo(() => {
    try {
      return hub?.config ? JSON.parse(hub.config) : undefined;
    } catch (error) {
      console.error('Error parsing hub config:', error);
      return undefined;
    }
  }, [hub]);

  // Set default values for when hubConfig is not ready
  const defaultValues = {
    data: null,
    loading: false,
    error: null,
    sensor: null,
  };
  
  // Only call the hook if we have a valid hubConfig
  const { data, loading, error, sensor } = hubConfig
    ? useGetDailyEnergySavingData(sensors, hub?.id || null, days, hubConfig)
    : defaultValues;
  

  return {
    data,
    loading,
    error,
    sensor,
    translate: (str: string) => t(str),
  };
};
